import { useCallback, useMemo, useState } from 'react'
import { useLeadCompanyRequiredFields } from '@user/features/LeadCompanyRequiredFields/LeadCompanyRequiredFieldsContext'
import { permissionDenied } from '@user/store/authorization/permissions'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getLeadList } from '@user/store/lead'
import { ConvertActions, ConvertButtonProps } from './typings'
import { useNavigate } from 'react-router-dom'

export function useActions(props: ConvertButtonProps): ConvertActions {
  const {
    canConvert,
    salesFunnelStages,
    lead: { id, salesFunnelStageId },
  } = props

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [convertFormOpen, setConvertFormOpen] = useState(false)
  const { hasMissing, requestConvert } = useLeadCompanyRequiredFields()
  const openConvertForm = useCallback(() => {
    const go = () =>
      navigate(`/opportunities/addOpportunity?source=lead&id=${id}`)
    if (hasMissing) requestConvert(go)
    else go()
  }, [navigate, id, hasMissing, requestConvert])
  const closeConvertForm = useCallback(() => setConvertFormOpen(false), [])
  const convertSuccessCallback = useCallback(() => {
    dispatch(getLeadList())
    closeConvertForm()
    navigate('/leads')
  }, [closeConvertForm, dispatch, navigate])

  const buttonTooltip = useMemo(() => {
    if (!canConvert) return permissionDenied
  }, [canConvert])

  const buttonDisabled = useMemo(() => {
    if (!canConvert) return true
    const result = salesFunnelStages.find((e) => e.id === salesFunnelStageId)
    if (result === undefined) return true
    if (result.name === 'Disqualified') return true

    return false
  }, [canConvert, salesFunnelStages, salesFunnelStageId])

  return {
    buttonTooltip,
    buttonDisabled,
    convertFormOpen,
    openConvertForm,
    closeConvertForm,
    convertSuccessCallback,
  }
}
